import { render, staticRenderFns } from "./permission-panel.vue?vue&type=template&id=d5139316&scoped=true"
import script from "./permission-panel.vue?vue&type=script&lang=ts"
export * from "./permission-panel.vue?vue&type=script&lang=ts"
import style0 from "./permission-panel.vue?vue&type=style&index=0&id=d5139316&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5139316",
  null
  
)

export default component.exports